export default "__VITE_ASSET__UgeHMvEe__"